export const getBlogItemImageWrapperStyles = {
	width: '100%',
};

export const getBlogItemImageStyles = {
	aspectRatio: '4/5',
};
export const blogItemCompactImageStyles = {
	...getBlogItemImageStyles,
	height: '15.313rem',
};
export const blogItemBoxStyles = {
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	height: '100%',
	backgroundColor: 'white',
};

export const blogItemRoundedCompactStyles = {
	...blogItemBoxStyles,
	borderRadius: '1rem',
	border: '1px solid',
	borderColor: 'neutrals.disabled',
	overflow: 'hidden',
	'.item-link-learn-label': {
		opacity: { xs: 1, md: 0 },
		transition: 'opacity 0.5s',
	},
	'&:hover .item-link-learn-label': {
		opacity: 1,
	},
};

export const blogItemCategoryPillStyle = {
	padding: '0.25rem 0.5rem',
	backgroundColor: 'info.light',
	display: 'inline-block',
};

export const blogItemContentStyles = {
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	marginTop: '1.25rem',
	marginBottom: '2rem',
	gap: '.5rem',
};

export const blogItemGridStyles = {
	display: 'grid',
	gap: '.5rem',
	gridTemplateColumns: 'auto 1fr',
	padding: '1rem 1rem 1.5rem',
	margin: 0,
	width: '100%',
	height: '100%',
	justifyContent: 'space-between',
};

export const blogItemGridLeftColStyles = {
	gridColumn: '1 / 2',
	justifySelf: 'start',
	alignContent: 'center',
	gridRow: '0',
	display: 'flex',
	flexDirection: 'row',
	gap: '.5rem',
	alignItems: 'center',
};

export const blogItemGridRightColStyles = {
	gridColumn: '2 / col-end',
	justifySelf: 'end',
	alignContent: 'center',
	gridRow: 'auto',
};

export const blogItemGridWideColStyles = {
	gridColumn: '1 / col-end',
};

export const blogItemButtonStyles = {
	marginTop: 'auto',
	width: 'fit-content',
};
